<template>
    <v-layout align-start 
                justify-start 
                row wrap 
                >
        <v-flex xs12 class="py-0 mb-0">           
            <span class="red--text py-0 my-0" v-if="errors.collect(attributes.variable,vuexnamespace)">{{ errors.first(attributes.variable, vuexnamespace) }}</span>            
        </v-flex>
        <v-flex d-flex :class="attributes.size">   
               
                <!--<code>{{ items }}</code>-->
            <v-autocomplete                        
                :label="attributes.placeholder"                                
                light                                                                                                              
                :items="items"     
                :item-text="attributes.displaytitle"
                item-value="id"
                v-model="result"                                                                
                flat
                chips
                clearable
                :prepend-inner-icon="attributes.icon"
                :multiple="attributes.multiple"                
                @change="changeResult"
                :data-vv-scope="vuexnamespace"
                :data-vv-name="attributes.variable"
                v-validate.immediate="attributes.rules"  
                >   
                
                
                <template
                    slot="selection"                    
                    slot-scope="data"                    
                    >
                    <v-chip
                        :selected="data.selected"
                        close
                        small
                        class="chip--select-multi lime darken-4"
                        @input="remove(data.item)"
                    >                  
                        {{ getTitle(data.item) }}
                    </v-chip>
                </template> 
                <template
                    slot="item"
                    slot-scope="data"
                    >
                    <template v-if="typeof data.item !== 'object'">
                        <v-list-tile-content v-text="data.item"></v-list-tile-content>
                    </template>
                    <template v-else>
                        <v-list-tile-content>
                            <v-list-tile-title v-html="getTitle(data.item)"></v-list-tile-title>
                            <v-list-tile-sub-title v-html="getSubTitle(data.item)"></v-list-tile-sub-title>
                        </v-list-tile-content>
                    </template>
                </template>
            </v-autocomplete>                                                                                                                
        </v-flex>
        <v-flex xs1></v-flex> 
        <v-flex :class="attributes.invertedsize">
            <v-btn
                fab
                color="transparent"
                light
                small
                v-on:click="onDialogToggled"
                v-if="attributes.withdialog">       
            
                <v-icon small>add</v-icon>
            </v-btn>            
        </v-flex>
        <createdialog :dialog="dialog" 
                    :formdata="itemsformdata" 
                    v-on:dialogtoggled="onDialogToggled"
                    v-if="attributes.withdialog">                        
        </createdialog>
        
    </v-layout>
</template>
<script>
import formselectsingleresult from "./FormSelectSingleResult.vue"
import formselectmultiresult from "./FormSelectMultiResult.vue"
import createdialog from "./MainDialog.vue"
import { mapGetters } from 'vuex';
export default {   
    inject: ['$validator'],
    props:[
        'attributes',
        'vuexnamespace'
    ],
    components: {
        formselectsingleresult: formselectsingleresult,
        formselectmultiresult: formselectmultiresult,
        createdialog: createdialog,
        
    },
    data() {
        return {
            formselectsingleresult:formselectsingleresult,
            formselectmultiresult: formselectmultiresult,
            createdialog: createdialog,
            dialog:false,
            formselectrules:[], 
            
        }
    },
    
    computed: {
        
        itemsnamespace: function() {
            return this.attributes.items.split('/')[0]
        },
        itemsformdata: function(){
            return this.$store.getters[this.itemsnamespace + '/formdata']
        },
        items: function() {            
            return this.$store.getters[this.attributes.items]        
        },
        result: {
            get() {return this.$store.getters[this.vuexnamespace + '/data'](this.attributes.variable)},
            set(val){this.$store.commit(this.attributes.setter, val)}
        }               
                        
    },
    methods: {
        
        isObject(o) {
            return o !== null && typeof o === 'object' && Array.isArray(o) === false;
        },
        
        getTitle (item) {
            return item[this.attributes.displaytitle]
        },
        getSubTitle (item) {
            return item[this.attributes.displaysubtitle]
        },
        onDialogToggled() {                
            this.dialog = !this.dialog
        },
        
        remove (item) {
           
            if(Array.isArray( this.result)) {                                  
                const index = this.result.indexOf(item.id)
                if (index >= 0) this.result.splice(index, 1) 
            } else {
                this.result=null
            }
         
        },
        changeResult(item) {            
            this.result=item
        }
    },
    created(){
       
        this.$store.getters[this.vuexnamespace + '/data'](this.attributes.variable)
    }
    
}
</script>